import { DisputeDetailsView } from "@portal/BaseComponents/Activites/RaiseADispute/DisputeDetailsView/DisputeDetailView";
import { AppPageParams } from "@portal/lib/router/constants/page-info";
import { useParams } from "react-router-dom";

function DisputeDetails() {
  const { dispute_id } = useParams<AppPageParams>();
  return <DisputeDetailsView open={Boolean(dispute_id)} id={dispute_id} />;
}

export { DisputeDetails };
